import type { User } from "../types";

export function avatarInitials(u: User): string {
  const name = u.full_name.trim();
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  if (name.length > 0) return name[0].toUpperCase();
  return (u.email[0] || "?").toUpperCase();
}
